import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/auth/login/page.tsx");
